
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 138 138","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M85.68 16.605l7.97 3.3L110.227 13 124.5 27.276l-6.905 16.575 3.3 7.966 16.605 6.838v20.192l-16.605 6.837-3.3 7.967 6.905 16.575-14.275 14.275-16.575-6.9-7.971 3.3-6.834 16.6H58.651l-6.834-16.6-7.97-3.3-16.576 6.9-14.275-14.275 6.905-16.575-3.3-7.967L0 78.847V58.655l16.6-6.838 3.3-7.966-6.905-16.575L27.271 13l16.575 6.904 7.971-3.3L58.651 0h20.195l6.834 16.604zM76.055 4.167H61.442L55.01 19.788l-11.171 4.625-15.592-6.496-10.333 10.334 6.496 15.591-4.625 11.167-15.617 6.438v14.608l15.617 6.437 4.625 11.167-6.496 15.592 10.333 10.333 15.592-6.492 11.17 4.625 6.434 15.617h14.613l6.433-15.617 11.17-4.625 15.593 6.492 10.333-10.333-6.496-15.592 4.625-11.167 15.62-6.437V61.447l-15.62-6.438-4.625-11.167 6.496-15.591-10.333-10.334-15.592 6.496-11.17-4.625-6.434-15.62z"}}),_c('path',{attrs:{"d":"M68.75 97.85c16.071 0 29.1-13.028 29.1-29.1 0-16.07-13.029-29.1-29.1-29.1-16.074 0-29.104 13.03-29.104 29.1 0 16.072 13.03 29.1 29.105 29.1zm0-4.166c-13.774 0-24.937-11.162-24.937-24.933 0-13.771 11.163-24.934 24.938-24.934 13.77 0 24.933 11.163 24.933 24.934 0 13.77-11.163 24.933-24.933 24.933z"}})])
          )
        }
      }
    